import {
    Add, DeleteOutline, ErrorOutline, FileCopy,
} from '@mui/icons-material';
import {
    Box, Button, IconButton, Tab, Tabs, Tooltip,
} from '@mui/material';
import { SyntheticEvent } from 'react';

type SetsConfigCultureGroup = Models.IngestConfigApi.SetsConfigs.SetsConfigCultureGroup;

interface CultureGroupTabsProps {
    groups: SetsConfigCultureGroup[];
    selectedIndex: number;
    duplicateNameIndexes: Set<number>;
    invalidGroupIndexes: Set<number>;
    onSelect: (index: number) => void;
    onAddGroup: () => void;
    onRemoveGroup: (index: number) => void;
    onCopyFromProduct: () => void;
}

export const CultureGroupTabs = ({
    groups,
    selectedIndex,
    duplicateNameIndexes,
    invalidGroupIndexes,
    onSelect,
    onAddGroup,
    onRemoveGroup,
    onCopyFromProduct,
}: CultureGroupTabsProps): JSX.Element => {
    const handleChange = (_event: SyntheticEvent, newValue: number): void => {
        onSelect(newValue);
    };

    return (
        <Box sx={{
            borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center',
        }}
        >
            <Tabs value={groups.length > 0 ? selectedIndex : false} onChange={handleChange}>
                {groups.map((group, index) => (
                    <Tab
                        icon={invalidGroupIndexes.has(index) ? (
                            <Tooltip title="This culture group has a set design conductor can't serve">
                                <ErrorOutline color="error" fontSize="small" />
                            </Tooltip>
                        ) : undefined}
                        iconPosition="end"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`group-${index}`}
                        label={group.name?.trim() || '(unnamed)'}
                        sx={duplicateNameIndexes.has(index) ? { color: 'error.main' } : undefined}
                    />
                ))}
            </Tabs>
            <Tooltip title="Add culture group">
                <IconButton color="secondary" size="small" onClick={onAddGroup}>
                    <Add />
                </IconButton>
            </Tooltip>
            {groups.length > 0 && (
                <Tooltip title="Remove group">
                    <IconButton
                        aria-label="remove group"
                        color="error"
                        size="small"
                        onClick={(): void => onRemoveGroup(selectedIndex)}
                    >
                        <DeleteOutline />
                    </IconButton>
                </Tooltip>
            )}
            <Tooltip title="Copy culture groups from another product's sets config">
                <Button
                    color="secondary"
                    size="small"
                    startIcon={<FileCopy />}
                    sx={{ ml: 'auto' }}
                    onClick={onCopyFromProduct}
                >
                    Copy from product
                </Button>
            </Tooltip>
        </Box>
    );
};
